import api from '@/lib/api'

const state = {
    facilityTypes: [],
    facilityStatuses: []
}

const getters = {
    facilityTypes(state) {
        return state.facilityTypes
    },
    facilityStatuses(state) {
        return state.facilityStatuses
    }
}

const actions = {
    getTypesList: {
        root: true,
        async handler({rootGetters, commit}, { apiCall, getter, mutation }) {
            if (!rootGetters[getter].length) {
                try {
                    const apiResponse = await apiCall()
                    commit(mutation, apiResponse.data, {root: true})
                } catch (error) {
                    const err = error?.response?.data?.message || error.message

                    this.$notify({
                        title: 'Error',
                        message: `Could not load data types from API: ${err}`,
                        type: 'error'
                    })

                    commit(mutation, [], {root: true})
                }
            }

            return rootGetters[getter]
        }
    },
    async getFacilityTypes({dispatch}) {
        return await dispatch(
            'getTypesList',
            {
                apiCall: api.types.loadFacilityTypes,
                getter: 'types/facilityTypes',
                mutation: 'types/SET_FACILITY_TYPES'
            }, { root: true }
        )
    },
    async getFacilityStatuses({dispatch}) {
        return await dispatch(
            'getTypesList',
            {
                apiCall: api.types.loadDisplayedStatusTypes,
                getter: 'types/facilityStatuses',
                mutation: 'types/SET_FACILITY_STATUSES'
            }, { root: true }
        )
    }
}

// mutations
const mutations = {
    SET_FACILITY_TYPES(state, payload) {
        state.facilityTypes = payload
    },
    SET_FACILITY_STATUSES(state, payload) {
        state.facilityStatuses = payload
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}